import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalRoutingModule } from './portal-routing.module';
import { PortalComponent } from './portal.component';
import { AdminModule } from './admin/admin.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { PortalResolve } from './portal.resolve';
import { ProfileModule } from './profile/profile.module';
import { AppMaterialModule } from '../shared/appMaterial/app-material.module';
import { ProfilePhotoModule } from './profile/profile-photo/profile-photo.module';
import { AvailabilityModule } from './profile/captain/availability/availability.module';
import { DescriptionModule } from './profile/captain/description/description.module';
import { EditAddressModule } from './profile/captain/address/edit/edit-address.module';
import { EditProfilePhotoModule } from './profile/profile-photo/edit/edit-profile-photo.module';
import { EditDescriptionModule } from './profile/captain/description/edit/edit-description.module';
import { EditAvailabilityModule } from './profile/captain/availability/edit/edit-availability.module';
import { PortalService } from './portal-service';
import { AddWaterBodiesComponent } from './admin/water-bodies/add/add-water-bodies.component';

// import { NgBusyModule } from 'ng-busy';
import { BoatyardModule } from './profile/captain/boatyard/boatyard.module';
import { VesselEditModule } from './profile/captain/boatyard/vessel-edit/vessel-edit.module';
import { ChartersGridModule } from './charters/charters-grid/charters-grid.module';
import { AddCharterModule } from './charters/add/add.module';
import { EditCharterModule } from './charters/edit/edit.module';
import { ManageCharterModule } from './charters/manage-charter/manage-charter.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { UnpaidChartersModule } from './charters/unpaid-charters/unpaid-charters.module';
import { TextMaskModule } from 'angular2-text-mask';
import { BrokerModule } from './broker/broker.module';
import { SelectServiceModule } from '../sign-up/become-a-captain/select-service/select-service.module';
import { ListGridModule } from '../shared/listGrid/listGrid.module';
import { AddWaterBodiesModule } from './admin/water-bodies/add/add-water-bodies.module';
import { CaptainChecklistModule } from './charters/manage-charter/captain-checklist/captain-checklist.module';
import { PaystubsModule } from './profile/captain/paystubs/paystubs.module';
import { AffiliateDashboardModule } from '../affiliate/affiliate-dashboard/affiliate-dashboard.module';
import { CharterCaptainsModule } from './profile/captain/charter-captains/charter-captains.module';
import { AssignCaptainsModule } from './profile/captain/charter-captains/assign-captains/assign-captains.module';
import { PublicModule } from '../public/public.module';
import { PostsModule } from './posts/posts.module';
import { CaptainDeletionRequestModule } from '../captain/captain-deletion-request/captain-deletion-request.module';
import { BookingsManagerModule } from './bookings-manager/bookings-manager.module';
import { MessagingModule } from './messaging-dashboard/messaging-dashboard.module';
import { BookingDetailsWrapperModule } from './bookings-manager/booking-details-wrapper/booking-details-wrapper.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { NavigationModule } from '../shared/navigation/navigation.module';

@NgModule({
  imports: [
    CommonModule,
    PortalRoutingModule,
    AppMaterialModule,
    MatMenuModule,
    MatButtonModule,
    MatDividerModule,
    AdminModule,
    FlexLayoutModule,
    SharedModule,
    ProfileModule,
    ProfilePhotoModule,
    EditAddressModule,
    AvailabilityModule,
    DescriptionModule,
    EditProfilePhotoModule,
    EditDescriptionModule,
    EditAvailabilityModule,
    ChartersGridModule,
    BookingsManagerModule,
    BookingDetailsWrapperModule,
    AddCharterModule,
    EditCharterModule,
    ManageCharterModule,
    SelectServiceModule,
    ListGridModule,
    CaptainChecklistModule,
    // NgBusyModule,
    BoatyardModule,
    VesselEditModule,
    MatExpansionModule,
    UnpaidChartersModule,
    TextMaskModule,
    BrokerModule,
    AddWaterBodiesModule,
    PaystubsModule,
    AffiliateDashboardModule,
    CharterCaptainsModule,
    AssignCaptainsModule,
    PaystubsModule,
    PublicModule,
    PostsModule,
    CaptainDeletionRequestModule,
    MessagingModule,
  ],
  declarations: [PortalComponent],
  exports: [PortalComponent],
  providers: [PortalResolve, PortalService],
})
export class PortalModule {}
